// export const API = 'http://localhost:5000/api'
export const API = 'https://flybus-server-production.up.railway.app/api'
    